import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { PaymentApi, LoopBackAuth, OtherPaymentApi } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { PAYMENT_METHOD, UPLOAD_TYPE } from '../../../enums';
import { Pagination } from '../../../interfaces';
import { finalize } from 'rxjs/operators';
import { formatEvent } from '@app/helpers/upload-input-formatter'    

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
export class PaymentListComponent extends BasicList {
  PAYMENT_METHOD: typeof PAYMENT_METHOD = PAYMENT_METHOD;
  UPLOAD_TYPE: typeof UPLOAD_TYPE = UPLOAD_TYPE;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'referenceNumber', placeholder: 'Order Reference', exact: true },
      { name: 'method', placeholder: 'Payment Method', exact: true, options: PAYMENT_METHOD },
      { name: 'reference', placeholder: 'Reference', exact: true },
      { name: 'paypalId', placeholder: 'Payer id', exact: true }
    ],
    filters: {}
  };
  searchOnlineStorePaymentsSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'referenceNumber', placeholder: 'Order Reference', exact: true },
      { name: 'method', placeholder: 'Payment Method', exact: true, options: PAYMENT_METHOD },
      { name: 'reference', placeholder: 'Reference', exact: true }
    ],
    filters: {}
  };
  onlineStoreParams: { [key: string]: any } = {};
  onlineStorePayments: Array<any>;
  onlineStorePagination: Pagination = {
    page: 1,
    limit: 10,
    total: 0
  };

  constructor(
    private paymentApi: PaymentApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService,
    private otherPayment: OtherPaymentApi
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.searchOnlineStorePaymentsSettings.searchFields.push(this.searchOnlineStorePaymentsSettings.searchableFields[0]);
    this.params = {
      order: 'dateCreated DESC'
    };
    this.onlineStoreParams = {
      order: 'dateCreated DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.paymentApi.search.bind(this.paymentApi),
        deleteById: this.paymentApi.deleteById.bind(this.paymentApi)
      },
      ModalService: this.modalService
    };
  }

  getOnlineStoreTransactions() {
    if (this.loading.onlineStorePayments) {
      return;
    }
    this.loading.onlineStorePayments = true;
    this.clearErrors();
    this.otherPayment
      .search({
        ...this.onlineStoreParams,
        offset: this.onlineStorePagination.limit * (this.onlineStorePagination.page - 1),
        limit: this.onlineStorePagination.limit
      })
      .pipe(finalize(() => {
        this.loading.onlineStorePayments = false;
      }))
      .subscribe(
        (response: any) => {
          this.onlineStorePayments = response.data && response.data.data || [];
          this.onlineStorePagination.total = response.data && response.data.total || 0;
        },
        error => {
          this.errors.onlineStorePayments = error.message;
        }
      );
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  searchOnlineStorePayments() {
    this.getOnlineStoreTransactions();
  }
}
